// extracted by mini-css-extract-plugin
export default {"wrapper":"qq-z","response":"rq-z","error":"sq-z","disabled":"tq-z","buttons":"uq-z","feedbackQuestionSection":"vq-z","yesNoWrapper":"wq-z"};